export default {
  home: '每日签到',
  turnOver: '幸运大转盘',
  activePages: '活动',
  IntegralRecord: '积分列表',
  rankingList: '点赞排行榜',
  store: '积分商城',
  goodsDetail: '商品详情',
  sureMsg: '兑换确认',
  exchange: '兑换记录',
  exchangeDetail: '兑换详情',
  ticket: '我的卡券',
  ticketDetail: '卡券详情',
}



// WEBPACK FOOTER //
// ./src/router/meta.js